// This mixin is used to validate the session menu items

export default {
  methods: {
    validarmenu(enable_abt_account) {
      try {
        if (enable_abt_account != undefined && enable_abt_account != {}) {
          if (enable_abt_account.config.enable_abt_account != undefined) {
            if (enable_abt_account.config.enable_abt_account === false) {
              return false
            } else {
              return true
            }
          } else {
            return true
          }
        }
      } catch (error) {
        return true
      }
      return true
    },
    checkIfRemoveRecharge(value){
      if (value) {
        for (var i = 0; i < this.mapMenuOptions.length; i++) {
          if (this.mapMenuOptions[i].value == 'municipality-recharge') {
            if (this.administrativeArea.config.enable_abt_account != undefined) {
              if (this.administrativeArea.config.enable_abt_account === false) {
                this.mapMenuOptions.splice(i, 1);
              }
            }
          }
        }
      }
    }
  
  }
}
